/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/permissions-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/permissions-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 * - Or run: npm run db:full-workflow (does everything)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/permissions-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-permissions-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/permissions.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Generated at: 2026-06-22T23:44:13.677Z
 * Source config: config/entities/permissions-entity-config.ts
 * Public fields: 4/4 total fields
 */

import { Type, Static } from "@sinclair/typebox";

// TypeBox schemas for runtime validation (public fields only)
export const PermissionsSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  perm_name: Type.String(), // perm_name field
  description: Type.Union([Type.String(), Type.Null()]), // description field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
});

export const CreatePermissionsSchema = Type.Object({
  perm_name: Type.String(), // perm_name field
  description: Type.Union([Type.String(), Type.Null()]), // description field
});

export const UpdatePermissionsSchema = Type.Object({
  perm_name: Type.String(), // perm_name field
  description: Type.Union([Type.String(), Type.Null()]), // description field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type PermissionsRow = Static<typeof PermissionsSchema>;
export type PermissionsInsert = Static<typeof CreatePermissionsSchema>;
export type PermissionsUpdate = Static<typeof UpdatePermissionsSchema>;

// Legacy type aliases for backward compatibility
export type Permissions = PermissionsRow;
export type CreatePermissions = PermissionsInsert;
export type UpdatePermissions = Static<typeof UpdatePermissionsSchema>;

// Field configuration metadata
export const PermissionsFieldConfig = {
  filterable: ["id"] as const,
  sortable: ["created_at"] as const,
  searchable: [] as const,
  required: ["id", "perm_name"] as const,
  readonly: ["id", "created_at"] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from "../../../../../config/search/global-search-config.js";

export interface PermissionsQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface PermissionsResponse {
  data: Permissions[] | null;
  error: Error | null;
  count?: number;
}

export interface SinglePermissionsResponse {
  data: Permissions | null;
  error: Error | null;
}
